import type { Item } from '@/common/api/types/items';
import type { DependencyTabAdapter, PlanSchedulingScenarioContext } from '../types';
import { createReadOnlyDependencyAdapter } from './createReadOnlyDependencyAdapter';

interface CreateEditableDependencyAdapterOptions {
  item: Item;
  loopId: number;
  canAddDependency: () => boolean;
  isEditable?: () => boolean;
  onAddDependency: (predecessorId: number, successorId: number) => Promise<void>;
  onRemoveDependency: (predecessorId: number, successorId: number) => Promise<void>;
  scenarioContext?: PlanSchedulingScenarioContext;
}

export const createEditableDependencyAdapter = ({
  item,
  loopId,
  canAddDependency,
  isEditable = () => true,
  onAddDependency,
  onRemoveDependency,
  scenarioContext,
}: CreateEditableDependencyAdapterOptions): DependencyTabAdapter => {
  const base = createReadOnlyDependencyAdapter({ item, scenarioContext });
  return {
    ...base,
    isEditable,
    canAddDependency,
    addDependency: onAddDependency,
    removeDependency: onRemoveDependency,
    loopId,
  };
};
